const columns = [
  {
    title: "接入用户",
    key: "user_cn_name",
  },
  {
    title: "终端号",
    key: "term_no",
  },
  {
    title: "接入渠道",
    key: "channel_cn_name",
  },
  {
    title: "部门名称",
    key: "dept_cn_name",
  },
  {
    title: "启用状态",
    key: "use_state",
    render:(h,{columns,row,index}) =>{
      return h("span",row.use_state === 1 ? "未启用" : "启用");
    }
  },
  {
    title: "操作",
    slot: "iconfont",
    iconClass: [
      {name: '启用', code: 'start', status: 2, type: 'success', size: 'small', Pname: 'Edit'},
      {name: '删除', code: 'end', status: 2, type: 'default', size: 'small', Pname: 'Edit'},
    ],
  },
];

export default columns;
